import { RestApiPayloadType, RestApiSenderConfig } from 'ihub/common';
import { AdvancedTourStep } from '../../shared-types';
import { RestApiSenderTourProps } from './rest-api-sender-tour-props';

export function getRestApiSenderBodySteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<RestApiSenderTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as RestApiSenderConfig;

	const getSteps = (): AdvancedTourStep[] => {
		switch (config.payloadType) {
			case RestApiPayloadType.JSON:
				return [
					{
						id: 'send-static-payload',
						selector: '[data-tour="send-static-payload"]',
						content:
							'Toggle this option to control what payload is sent. If unchecked, the input record data will be sent as-is. If checked, a static payload will be sent for each record.',
					},
					...(config.sendStaticPayload
						? [
								{
									id: 'static-payload',
									selector: '[data-tour="static-payload"]',
									content:
										'Provide a static JSON payload to send with each request when enabled. This field supports expressions, allowing dynamic values to be constructed.',
								},
							]
						: []),
				];
			case RestApiPayloadType.FormData:
			case RestApiPayloadType.EncodedFormData:
				return [
					{
						id: 'body-add-key-value',
						selector: '[data-tour="body-add-key-value"]',
						content: 'Add an additional header property to the request.',
					},
					{
						id: 'body-dictionary-item-key',
						selector: '[data-tour="body-dictionary-item-key"]',
						content: 'The key value to assign to the form data',
					},
					{
						id: 'body-dictionary-item-value',
						selector: '[data-tour="body-dictionary-item-value"]',
						content: 'The value that will be assigned to the form data.',
					},
					{
						id: 'body-delete-dictionary-item',
						selector: '[data-tour="body-dictionary-item-delete"]',
						content: 'Removes the form data row and all of its config',
					},
				];
			default:
				return [];
		}
	};

	return [
		{
			id: 'payload-type',
			selector: '[data-tour="payload-type"]',
			content:
				'Select the payload type (default is "JSON"). This determines the value set in the "Content-Type" header of the REST request.',
		},
		...getSteps(),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
